<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P0003601.installation.preventiongel.titre' | translate"
      [description]="
        'P0003601.installation.preventiongel.description' | translate
      "
    >
    </app-header-configuration>

    <div class="my-2">
      <div class="row">
        <div class="col">
          <ion-label class="color-medium text-uppercase">{{
            'P0003600.installation.preventiongel.typeFonctionHorsGel.title'
              | translate
          }}</ion-label>
        </div>
      </div>
    </div>

    <div class="my-2 mb-3">
      <app-affichage-warning
        [name]="'configuration.presentationmiseenservice.warning' | translate"
        icon="fa-regular fa-exclamation-circle"
      >
      </app-affichage-warning>
    </div>

    @if (hasProduitP00032() > 0 && hasProduitP00030() > 0) {
      <app-label-configuration
        [titleListe]="
          'P0003601.installation.prevention.capteurTemperatureReferenceHorsGel.smallTitle'
            | translate
        "
        [value]="
          actionStack!.getValue('fvsICapteurTemperatureReferenceHorsGel')
        "
        [liste]="P0003601CapteurTemperatureEnum"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.FiltrationVS_Installation,
            'fvsICapteurTemperatureReferenceHorsGel',
            $event,
            null
          )
        "
      >
      </app-label-configuration>
    }

    <app-label-configuration
      [titleListe]="
        'P0003601.installation.prevention.seuilTemperatureReferenceHorsGel.smallTitle'
          | translate
      "
      [value]="actionStack!.getValue('fvsPSeuilTemperatureHorsGel')"
      [liste]="P0003601SeuilTemperatureHorsGel()"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.FiltrationVS_Parametrage4,
          'fvsPSeuilTemperatureHorsGel',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    <app-label-description
      [description]="
        'P0003601.installation.preventiongel.typeFonctionHorsGel.description'
          | translate
      "
    ></app-label-description>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
